const constants = {
    DEFAULT_POST_LENGTH: 250,
    DEFAULT_COMMENT_LENGTH: 250,
    DEFAULT_NOTIFICATION_SUBTEXT_LENGTH: 65,
    MINUTES_IN_HOUR: 60,
    MINUTES_IN_DAY: 60 * 24,
    MINUTES_IN_WEEK: 60 * 24 * 7,
    DIRECTORY_LEVEL_LIMIT: 2,
    DEFAULT_DIR_NAME: "root",
    APP_VERSION: "2.6.0",
    VERSION_NUMBER: 58,
    MIN_PROFILE_PROGRESS: 51,
    RECRUIT_SUBSCRIPTION_CODE: "RECRUITS_SUBSCRIPTION",
    STORAGE_UPGRADE_CODE: "PRODUCT_CODE_PROFILE_USAGE",
    NZ_SCOUT_REPORT_CODE: "NZ_SCOUT_REPORT",
    MEDIUM_SCREEN_WIDTH: 485,
    SMALL_SCREEN_WIDTH: 365,
    DEFAULT_AUTO_SEARCH_LIMIT: 25,
    DEFAULT_CLICK_THROUGH_URL: "https://1rink.com",
    NON_PORTAL_ID: 0,
    MAX_HEIGHT: 83,
    MIN_HEIGHT: 48,
    MAX_WEIGHT: 450,
    MIN_WEIGHT: 0,
    ALLOWED_FILE_TYPES: ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'application/pdf', 'text/plain', 'video/mp4', 'video/quicktime'],
    MAX_FILE_SIZE: 146800640, // In Bytes
    MAX_IMAGE_HEIGHT: 15200,
    MAX_IMAGE_WIDTH: 25600,
    MAX_POST_FILE_LIMIT: 10,
    RECRUITS_MORE_INFO: "https://www.1rink.com/get-scouted",
    STRIPE_PAYMENT_MANAGER: "STRIPE_PM",
    RC_PAYMENT_MANAGER: "RC_PM",
    RINKNET_PAYMENT_MANAGER: "RINKNET_PM",
    MIN_PDF_ZOOM : 0,
    MAX_PDF_ZOOM: 12,
    CHOICE_QUESTION_TYPE: 'choice',
    LONG_QUESTION_TYPE: 'long',
    ENTITLEMENT_PREMIUM_RC: 'premium',
    OFFER_NZ_REPORT_RC: '1Rink NeutralZone Scouting Reports',
    PRIVACY_POLICY: "https://www.rinknet.com/privacy-policy",
    PROFILE_MEDIA_LIMIT: 500,
    PROFILE_MEDIA_PREVIEW_LIMIT: 3,
    PROFILE_HIGHLIGHT_PREVIEW_LIMIT: 1,
    HIGHLIGHT_VIDEO_IMAGE_LIMIT: 3,
    HIGHLIGHT_VIDEO_VIDEO_LIMIT: 3,
    ADD_IMAGES_STEP_HIGHLIGHT_VIDEO: 1,
    ADD_VIDEO_STEP_HIGHLIGHT_VIDEO: 2,
    CONFIRMATION_STEP_HIGHLIGHT_VIDEO: 3,
    ENTER_KEY_UP: 'Enter',
    RECRUIT_CONNECTIONS_MORE_INFO: "https://www.1rink.com/hockey-connections",
    PARENT_USER_TYPE_CODE: "PARENT",
    LINK_USER_INFO_ARTICLE: "https://support.1rink.com/portal/en/kb/articles/how-to-i-link-my-1rink-account-to-a-player",
    DEFAULT_ROUTE: "/home/dashboard",
    COMMENT_PREVIEW_LIMIT: 3
}

export default constants;
